<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              NEW ZEALAND ELECTRONIC TRAVEL AUTHORITY (NZeTA)
            </h2>
            <p class="vmc-text-primary-2 letter-spacing-1 mb-0">
              By Veritas Admin — May 04, 2025
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center pt-4">
            <p class="my-3 text-left">
              Effective 01 April 2025, the NZeTA will be required for present onboard crew vessels calling New Zealand.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewZealandElectronicTravelAuthority2025"
}
</script>

<style scoped>

</style>
